import React from 'react';
import PropTypes from 'prop-types';

import Row from 'components/Layout/Row';
import Column from 'components/Layout/Column';

import loadingScreenContent from 'utils/loadingScreenContent';

import Spinner from './Spinner';

const Loading = ({
  height,
  width,
  style,
  color,
  withInfo = false,
  index = 0,
}) => (
  <>
    <Row
      className="center"
      style={{ minHeight: height || 'calc(100vh - 109px)', ...style }}>
      <Column>
        {withInfo && (
          <>
            <div>{loadingScreenContent[index].icon}</div>
            <div>{loadingScreenContent[index].hint}</div>
          </>
        )}
        <Spinner width={width} color={color} />
        {withInfo && (
          <p
            style={{
              ...(withInfo ? { fontSize: '12px', opacity: 0.8 } : {}),
            }}>
            Loading page...
          </p>
        )}
      </Column>
    </Row>
  </>
);

Loading.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  withInfo: PropTypes.bool,
  index: PropTypes.number,
};

export default Loading;
